import httpClient from "./httpClient";

export function getPermissionsByRole(roleId) {
  return httpClient.get("/permissions", { params: { roleId } }).then((res) => res.data.data);
}

export function savePermissions(payload) {
  return httpClient.post("/permissions", payload).then((res) => res.data);
}
